import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Volunteers = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        expertise: 'Medical',
        contact: '',
        message: ''
    });

    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = () => {
        const { name, email, expertise, contact, message } = formData;

        // Basic validation
        if (!name || !email || !contact) {
            alert('Please fill in all required fields');
            return;
        }

        const whatsappNumber = '+94771581869';
        const whatsappMessage = `Volunteer Application:%0AName: ${name}%0AEmail: ${email}%0AExpertise: ${expertise}%0AContact: ${contact}%0AMessage: ${message}`;
        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

        // Open WhatsApp in a new tab
        window.open(whatsappURL, '_blank');

        // Set submitted state to true
        setSubmitted(true);

        // Reset form after submission
        setFormData({
            name: '',
            email: '',
            expertise: 'Medical',
            contact: '',
            message: ''
        });
    };

    return (
        <div className="container py-4 py-md-5 px-3 px-md-4 px-lg-5">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10 col-xl-8">
                    <h2 className="display-5 fw-bold mb-3 mb-md-4 text-center" style={{ fontFamily: 'Georgia' }}>
                        Join with our Marcsri family and help us to take care of these inmates
                    </h2>

                    <p className="lead mb-4 mb-md-5 text-center">
                        Spend time with our children and elderly mothers and fathers, lend a helping hand
                    </p>

                    {submitted ? (
                        <div className="alert alert-success text-center">
                            Thank you for your application! We've opened WhatsApp for you to complete the submission.
                            If it didn't open, please send your details to +94771581869.
                        </div>
                    ) : (
                        <div className="row g-3 justify-content-center">
                            <div className="col-12 col-md-10 col-lg-8">
                                <label htmlFor="name" className="form-label">Your Name *</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-12 col-md-10 col-lg-8">
                                <label htmlFor="email" className="form-label">Your Email *</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-12 col-md-10 col-lg-8">
                                <label htmlFor="expertise" className="form-label">Area of Expertise *</label>
                                <select
                                    className="form-select"
                                    id="expertise"
                                    value={formData.expertise}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="Medical">Medical</option>
                                    <option value="Teaching">Teaching</option>
                                    <option value="Special Care Trainee">Special Care Trainee</option>
                                    <option value="Technician">Technician</option>
                                </select>
                            </div>

                            <div className="col-12 col-md-10 col-lg-8">
                                <label htmlFor="contact" className="form-label">Contact No. *</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="contact"
                                    value={formData.contact}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="col-12 col-md-10 col-lg-8">
                                <label htmlFor="message" className="form-label">Your Message</label>
                                <textarea
                                    className="form-control"
                                    id="message"
                                    rows="4"
                                    value={formData.message}
                                    onChange={handleChange}
                                ></textarea>
                            </div>

                            <div className="col-12 col-md-10 col-lg-8 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-primary w-100 py-2"
                                    onClick={handleSubmit}
                                    style={{ fontSize: '1.1rem' }}
                                >
                                    Submit via WhatsApp
                                </button>
                            </div>

                            <div className="col-12 col-md-10 col-lg-8 text-center mt-2">
                                <small className="text-muted">* Required fields</small>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Volunteers;